module.exports = __webpack_public_path__ + "img/sld_ch_4_t1_green.12d25bc4.svg";